import { render, staticRenderFns } from "./company_user_item_device.vue?vue&type=template&id=e513c860"
import script from "./company_user_item_device.vue?vue&type=script&lang=js"
export * from "./company_user_item_device.vue?vue&type=script&lang=js"
import style0 from "./company_user_item_device.vue?vue&type=style&index=0&id=e513c860&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports